import SuperDropdown, { SuperDropdownItem } from "../dropdown/SuperDropdown";
import DefaultDropdownItem from "../dropdown/DefaultDropdownItem";
import { UseComboboxStateChange } from "downshift";
import IsRequired from "../formcontrols/common/IsRequired";
import ValidationErrorMessage from "../formcontrols/ValidationErrorMessage";
import { get } from "lodash";
import { FormikProps } from "formik";

type ID = "Formular1" | "Formular2";
interface Item {
  id: ID;
  navn: string;
}

const AutoCompleteFormular = ({
  onSelectedItemEvent,
  onBlur,
  focusInputOnMount,
  isLocked,
  initialValue,
  label,
  isRequired,
  id,
  formik,
}: {
  onSelectedItemEvent: (
    event: UseComboboxStateChange<SuperDropdownItem<Item, "id">>,
  ) => void;
  onBlur?: React.FocusEventHandler<HTMLInputElement> | undefined;
  focusInputOnMount?: boolean | undefined;
  isLocked: boolean;
  initialValue: ID;
  id: string;
  formik: FormikProps<any>;
  label?: string;
  isRequired?: boolean;
}) => {
  const data: Item[] = [
    { id: "Formular1", navn: "Formular 1" },
    { id: "Formular2", navn: "Formular 2" },
  ];

  const initialSelectedItem = data.find((e) => e.id === initialValue);
  const wasTouched = get(formik.touched, id);
  const errorMessage = get(formik.errors, id) as string | undefined;

  return (
    <>
      <label className="form-label" style={{ whiteSpace: "nowrap" }}>
        {label ? label : "\u00A0"}
        {isRequired && <IsRequired />}
      </label>
      {isLocked ? (
        <input
          value={data.find((e) => e.id === initialValue)?.navn}
          className="form-control"
          disabled
        />
      ) : (
        <SuperDropdown
          items={data}
          itemsIdKey="id"
          itemToElement={(item) => (
            <DefaultDropdownItem label={item.navn ?? ""} />
          )}
          itemToString={(item) => item?.navn ?? ""}
          onSelectedItemEvent={onSelectedItemEvent}
          placeholder="Ingen"
          filterKeys={["navn"]}
          classNameContainer="w-100"
          onBlur={onBlur}
          focusInputOnMount={focusInputOnMount}
          disabled={isLocked}
          initialSelectedItem={initialSelectedItem}
          asDropdown
        />
      )}
      <ValidationErrorMessage
        touched={wasTouched}
        errorMessage={errorMessage}
      />
    </>
  );
};

export default AutoCompleteFormular;
